const query = (id, isPreview) => `{
    profileTeams(id: "${id}", preview: ${isPreview}){
    name
    profileCollectionCollection(limit:20){
      items{
        title
        text
        svgColor
        link {
          name
          url
          label
          ariaLabel
          title
          target
          scrollToElementId
          imageType
          gaEventClass
          gaEventLabel
        }
        images{
          altText
          imageDesktop {
            title
            description
            contentType
            fileName
            size
            url
            width
            height
          }
        }
      }
    }
  }
}
  
  `
module.exports = { query }
